export default __webpack_public_path__ + "src/public/Maintenance.svg";